import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'ftg_germany',
} as IModuleProps;
